import * as React from "react";

export const FormFieldContext = React.createContext<{ name: string }>(
  {} as { name: string },
);
